<template>
  <Modal v-model:open="isOpen" :close-button-exists="false">
    <div class="mt-5 flex flex-col items-center text-center">
      <h1 class="mb-8 text-center text-3xl font-semibold text-gray-700">
        Willkommen zurück
      </h1>
      <p class="my-4 text-lg leading-6 text-gray-600">
        Wir haben Ihre E-Mail Adresse in unserem System wieder erkannt. Wahrscheinlich haben Sie bereits eine
        Bürgschaft angefangen abzuschließen oder sogar bereits abgeschlossen.
        Sie können sich ganz einfach über unseren Easylogin ins Dashboard einloggen und alle Informationen zu Ihrem
        Status einsehen.
      </p>
      <a href="/easylogin" class="mt-4 block w-full whitespace-nowrap rounded-full border border-transparent bg-green-400 py-3 text-base font-medium text-white hover:bg-green-300 md:w-2/3">
        Jetzt anmelden
      </a>
    </div>
  </Modal>
</template>

<script setup>

import Modal from "../../common/components/Modal.vue"
import {onMounted, ref} from "vue";
import emitter from "../../common/utils/eventbus";

const isOpen = ref(false);

onMounted(() => {
  emitter.on('open-user-exists', (value) => {
    isOpen.value = value;
  });
})

</script>
